app.component("patientEmail", {
	templateUrl: "app/src/js/components/patientHeader/patientEmail/patientEmail.html",
	controller: "patientEmailController",
	bindings: {
		hide: "&",
	},
});

app.controller("patientEmailController", [
	"$scope",
	"CurrentPatient",
	"PatientAPI",
	"$timeout",
	function ($scope, CurrentPatient, PatientAPI, $timeout) {
		this.$onInit = function () {
			// $scope.preop = PreOp;
			$scope.PA = PatientAPI;
			this.PA = PatientAPI;
			$scope.CP = CurrentPatient;
            $scope.patientEmail = {value: null};
		};

		const focusTimeout = $timeout(function () {
			// focus on input when component opens
			const input = document.querySelector("#patientEmail");
			if (input) input.focus();
		}, 200);

		// the popover can be dismissed before the timeout fires
		$scope.$on("$destroy", function () {
			$timeout.cancel(focusTimeout);
		});

		$scope.savePatientEmail = function (email) {
			const previousEmail = $scope.CP.patient.email;
			$scope.CP.patient.email = email;
			$scope.PA.isProcessing = true;
			$scope.PA.update($scope.CP.patient)
				.then(function (resp) {
					$scope.CP.setPatient(resp.data);
				})
				.then(function () {
					$scope.PA.isProcessing = false;
					$scope.$ctrl.hide();
				})
				.catch(function (err) {
					// Not saved, so the header goes back to showing what is on file.
					$scope.CP.patient.email = previousEmail;
					$scope.PA.isProcessing = false;
					console.error("Failed to save email:", err && err.status);
				});
		};
	},
]);
